import { useMutation } from '@tanstack/react-query';
import { post } from '@/lib/api/client';

/** `gender` and `language` are numeric enums on the API. */
export const GENDER = { male: 0, female: 1 } as const;
export const LANGUAGE = { en: 0, es: 1 } as const;

export interface RegistrationRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  gender: number;
  language: number;
}

export function useRegister() {
  return useMutation({
    mutationFn: (payload: RegistrationRequest) =>
      // The old form posted its entire component state, validation flags and
      // all (`firstNameValid: 'warning'` …), straight to the API. Only the
      // fields the endpoint declares are sent now.
      post<unknown>('oauth/local/register', payload),
  });
}
